import type { CacheParams, FetchCache, FetchCacheController } from 'utils/fetchCache/types';

class FetchCacheControllerClass implements FetchCacheController {
    private _cache = {} as FetchCache;

    getCache(): FetchCache {
        return this._cache;
    }

    setCache(key: keyof FetchCache, value: FetchCache[keyof FetchCache]): void {
        this._cache[key] = value;
    }

    getCacheByKey(key: keyof FetchCache, params: CacheParams): FetchCache[keyof FetchCache] {
        if (!params.cacheable) return null;

        return this._cache[key];
    }

    invalidateCache(key: keyof FetchCache | (keyof FetchCache)[]): void {
        if (Array.isArray(key) && key.length > 0) key.forEach((k) => this._invalidateCache(k));
        else this._invalidateCache(key as keyof FetchCache);
    }

    _invalidateCache(key: keyof FetchCache): void {
        if (key in this._cache) this._cache[key] = null;
    }
}

export const initializeFetchCache = (): FetchCacheControllerClass => new FetchCacheControllerClass();

export default {};
